import angular from 'angular'
import StyleGuideComponent from './style-guide.component'

export default angular
  .module('styleGuide', [])
  .component('styleGuide', StyleGuideComponent)
  .name
